import {phoneFormattedRe} from '@deliveriesondemand/dod-regexes';
import {isSupportedSMSNumber} from '@deliveriesondemand/dod-utils';

import Checkbox from '-/components/fields/Checkbox';
import DealInfoService from '-/services/DealInfoService';

export default props => {
    const {creditorName, name, cellphone, onChange} = props;
    const isCashDeal = DealInfoService.isCashDeal();
    const isPhoneValid = phoneFormattedRe.test(cellphone) && isSupportedSMSNumber(cellphone);
    const loanLabel = isCashDeal ? 'purchase' : 'loan application';
    const purposeLabel = isCashDeal ? 'purchase' : 'auto loan';
    const template = `would like to receive text updates from ${creditorName} about my ${loanLabel} and process. Only texts regarding my ${purposeLabel} will be sent. Standard messaging rates and data apply.`;

    if (!isPhoneValid) {
        return null;
    }

    return (
        <Checkbox handleCheckboxChange={onChange} disabled={!isPhoneValid}>
            {name ? `I, ${name}, ` : 'I '}
            {template}
            {isPhoneValid && ` (${cellphone})`}
        </Checkbox>
    );
};
